import { CopilotEntrypointType, CopilotStudyLevel, PromptVersion } from '../enums';
import { RenderCopilotRequest } from './RenderCopilotRequest';

export class RenderEntrypointCopilotCommand extends CustomEvent<RenderCopilotRequest> {
	constructor(
		entrypointType: CopilotEntrypointType,
		element: HTMLElement,
		studyLevel: CopilotStudyLevel,
		contextData?: { [key: string]: string },
		promptVersion?: PromptVersion
	) {
		const detail = { element, entrypointType, contextData, studyLevel, promptVersion };

		super('', { detail });
	}
}
